import { ApprovalableTypeEnum } from 'api-hooks/common';
import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { StyleObject } from 'styletron-standard';

import { ScheduleCardHeader } from '../style';

export default function ApprovalBankCashCard() {
  const { t } = useTranslation();
  const values = HOCWatchValue({ keys: ['approvalableType', 'approvalable'] });
  const { navigate } = useNavigation();

  const onViewOldData = ({ id, approvalableType }) => {
    const params = {
      id,
    } as const;
    if (approvalableType === ApprovalableTypeEnum.BankTransaction) {
      navigate(NavigationRoutes.BankTransactionsView, params);
    }
    if (approvalableType === ApprovalableTypeEnum.CashTransaction) {
      navigate(NavigationRoutes.CashTransactionsView, params);
    }
  };

  return (
    <CardSection>
      <ScheduleCardHeader $style={style}>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', {
            extra: t(
              `common:${
                values.approvalableType === ApprovalableTypeEnum.BankTransaction
                  ? 'bank_transaction'
                  : 'cash_transaction'
              }`,
            ),
          })}
        </Text>
        <Button
          buttonType="secondary"
          onClick={() =>
            onViewOldData({
              id: values.approvalable.id,
              approvalableType: values.approvalableType,
            })
          }
        >
          {t('common:view_details')}
        </Button>
      </ScheduleCardHeader>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.transactionAt"
            label={t('common:transaction_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text"
          name="approvalable.description"
          label={t('common:description')}
        />
      </FullContainer>
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:account')}
            name={`approvalable.${
              values.approvalableType === ApprovalableTypeEnum.BankTransaction
                ? 'bank'
                : 'cash'
            }AccountName`}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            label={t('common:amount')}
            name="approvalable.amount"
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
